// eslint-disable-next-line import/prefer-default-export
export function reduce(codes, rules) {
  return codes.reduce((reduced, code) => {
    reduced[code] = rules;

    return reduced;
  }, {});
}
